module.exports = __webpack_public_path__ + "img/DualRing-1.1s-200px.a9264ec7.svg";